export class MissingAuthTokenError extends Error {
  constructor(public readonly url: string) {
    super();
  }
}
